var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-alert',{staticClass:"mb-2",attrs:{"type":"warning","showIcon":false,"message":_vm.$t('network.vpc_network.vpc_action_refresh'),"banner":""}}),_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }